import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getProfilePath = () => urlHelper('/profile');
